export { default as InternalLinkWrapper } from './InternalLinkWrapper';
